/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthFastLaneEndpointRequest
 */
export interface AuthFastLaneEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthFastLaneEndpointRequest
     */
    password: string;
}

export function AuthFastLaneEndpointRequestFromJSON(json: any): AuthFastLaneEndpointRequest {
    return AuthFastLaneEndpointRequestFromJSONTyped(json, false);
}

export function AuthFastLaneEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthFastLaneEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': json['password'],
    };
}

export function AuthFastLaneEndpointRequestToJSON(value?: AuthFastLaneEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
    };
}


